import { BROKER_LINKS } from "@/data/brokers";
import { TECHNICAL_BROKERS } from '@/mocks/technical';
import { SectionHeading } from './ui';

export default function BrokerSection() {
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <SectionHeading
        eyebrow="Nhà môi giới"
        title="Tìm hiểu điều kiện giao dịch"
        subtitle="So sánh các điều kiện giao dịch và tìm hiểu thêm về nền tảng, Spread, Commission và yêu cầu ký quỹ của các nhà môi giới."
      />

      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        {TECHNICAL_BROKERS.map((b) => (
          <div key={b.name} className="flex flex-col rounded-2xl border border-slate-200/80 bg-slate-50/50 p-5">
            <div className="flex items-center gap-3">
              <span
                className="flex h-11 w-11 items-center justify-center rounded-xl font-display text-base font-bold text-white"
                style={{ backgroundColor: b.color }}
              >
                {b.initial}
              </span>
              <div>
                <p className="text-sm font-bold text-slate-800">{b.name}</p>
                <p className="text-[11px] text-slate-400">{b.regulation}</p>
              </div>
            </div>

            <div className="mt-4 space-y-2.5">
              <Spec label="Nền tảng" value={b.platform} />
              <Spec label="Spread" value={b.spread} />
              <Spec label="Commission" value={b.commission} />
              <Spec label="Đòn bẩy" value={b.leverage} />
            </div>

            <div className="mt-5 flex gap-2">
              <a href={BROKER_LINKS[b.name]||'#'}
                className="w-full text-center whitespace-nowrap rounded-lg bg-violet-600 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-violet-700"
              >
                Mở tài khoản
              </a>
            </div>
          </div>
        ))}
      </div>

      <p className="mt-6 text-[11px] leading-relaxed text-slate-400">
        Công cụ này chỉ nhằm mục đích cung cấp thông tin và phân tích dữ liệu. Các mức Pivot và Fibonacci chỉ là các mức giá được
        tính toán theo phương pháp tương ứng, không phải tín hiệu giao dịch. Phân tích dữ liệu chiến lược dựa trên dữ liệu được
        cung cấp và không đảm bảo kết quả trong tương lai.
      </p>
    </section>
  );
}

function Spec({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between gap-2 border-b border-slate-200/60 pb-2 text-xs">
      <span className="text-slate-400">{label}</span>
      <span className="text-right font-medium text-slate-700">{value}</span>
    </div>
  );
}